import { GzFirewallAdvancedRulesFormWebComponent } from './component/GzFirewallAdvancedRulesFormWebComponent';

export { GzFirewallAdvancedRulesFormWebComponent };
